export const HOST_TEMPLATE_TYPES = Object.freeze({
  ANY: 'ANY',
  EMAIL: 'EMAIL',
  PAGE: 'PAGE',
  BLOG_POST: 'BLOG_POST',
  BLOG_LISTING: 'BLOG_LISTING',
  KNOWLEDGE_BASE: 'KNOWLEDGE_BASE',
  NONE: 'NONE',
  MEMBERSHIP: 'MEMBERSHIP',
  QUOTE: 'QUOTE',
  WEB_INTERACTIVE: 'WEB_INTERACTIVE'
});